import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';

const AdresseAutocomplete = ({ value, onChange, onSelect }) => {
  return (
    <PlacesAutocomplete
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      searchOptions={{
        componentRestrictions: { country: ['fr'] }
      }}
      debounce={250}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div style={{ position: "relative" }}>
          <input
            {...getInputProps({
              placeholder: 'Adresse complète',
              className: 'annonce-input',
              autoComplete: 'off',
            })}
          />
          {suggestions.length > 0 && (
            <div style={{
              position: "absolute", background: "#fff", zIndex: 10, border: "1px solid #ccc", width: "100%"
            }}>
              {loading && <div style={{ padding: 8 }}>Chargement...</div>}
              {suggestions.map(suggestion => (
                <div
                  {...getSuggestionItemProps(suggestion, { className: "suggestion-item" })}
                  key={suggestion.placeId}
                  style={{
                    padding: 8,
                    cursor: "pointer",
                    background: suggestion.active ? "#f2f2f2" : "#fff"
                  }}
                >
                  {suggestion.description}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default AdresseAutocomplete;